import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';
import useFeatureVariable from '../../useFeatureVariable';

const useAltView = (cid: string) => {
  const { abbrBrand, market } = useContext(BrandInfoContext);
  const altViewFeatureEnabled = useEnabledFeature(
    `cat-alt-view-${market}-${abbrBrand}`
  );
  const altViewExperimentEnabled = useEnabledSegment(`${abbrBrand}07`);
  const isEnabledForCid = useFeatureVariable(
    `cat-alt-view-${market}-${abbrBrand}`
  )
    ?.categoryId.split(',')
    .some((altViewCid: string) => altViewCid === cid || altViewCid === 'all');

  return altViewFeatureEnabled && altViewExperimentEnabled && !!isEnabledForCid;
};

export default useAltView;
